import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const EstimatedInvoiceSummary = ({ selectedPlant }) => {
  const [avgExportedAmount, setAvgExportedAmount] = useState(0);
  const [avgConsumedAmount, setAvgConsumedAmount] = useState(0);
  const [totalEstimatedBill, setTotalEstimatedBill] = useState(0);
  const [nextBillingMonth, setNextBillingMonth] = useState('');
  const [dateRange, setDateRange] = useState('');

  const getDisplayPlantName = (plant) => {
    switch (plant) {
      case 'Bodyknits':
        return 'Bodynits';
      case 'Sweelee':
        return 'Swee Lee';
      default:
        return plant;
    }
  };

  const displayPlantName = getDisplayPlantName(selectedPlant);

  const getNextMonthLabel = (monthKey) => {
    const [monthStr, yearStr] = monthKey.split('-');
    const monthMap = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
    };
    const monthIndex = monthMap[monthStr];
    const year = parseInt('20' + yearStr, 10);

    const date = new Date(year, monthIndex + 1); // next month
    const nextMonth = date.toLocaleString('default', { month: 'short' });
    const nextYearShort = String(date.getFullYear()).slice(-2);
    return `${nextMonth}-${nextYearShort}`;
  };

  const fetchRevenueData = useCallback(async () => {
    try {
      const response = await axios.post('/fmrequest', { plant: selectedPlant });
      if (Array.isArray(response.data) && response.data.length > 0) {
        const revenueData = response.data[0].Revenue;
        const parsedRevenue = typeof revenueData === 'string' ? JSON.parse(revenueData) : revenueData;

        const monthKeys = Object.keys(parsedRevenue);
        const firstMonthKey = monthKeys[0];
        const lastMonthKey = monthKeys[monthKeys.length - 1];

        setNextBillingMonth(getNextMonthLabel(lastMonthKey));
        setDateRange(`${firstMonthKey} to ${lastMonthKey}`);

        let totalExport = 0;
        let totalConsumed = 0;
        let count = 0;

        Object.values(parsedRevenue).forEach((monthData) => {
          const exported = monthData['Exported Generation']?.Amount;
          const consumed = monthData['Consumed Generation']?.Amount;
          if (typeof exported === 'number' && typeof consumed === 'number') {
            totalExport += exported;
            totalConsumed += consumed;
            count++;
          }
        });

        if (count > 0) {
          const avgExport = totalExport / count;
          const avgConsume = totalConsumed / count;
          setAvgExportedAmount(avgExport);
          setAvgConsumedAmount(avgConsume);
          setTotalEstimatedBill(avgExport + avgConsume);
        }
      }
    } catch (error) {
      console.error('Error fetching revenue data:', error);
    }
  }, [selectedPlant]);

  useEffect(() => {
    fetchRevenueData();
  }, [fetchRevenueData]);

  return (
    <div  style={{
    padding: '25px',border: '2px solid #bbb',marginTop: '20px',maxWidth: '600px',margin: '0 auto',textAlign: 'center',    
  }}>
      <h3 style={{ color: 'red' }}>TREK RENEWABLE ENERGY SOLUTIONS PTE. LTD.</h3>
      <h4>{displayPlantName} Project</h4>
      <h5 style={{ color: '#40826D', marginTop: '20px' }}>Estimated Billing Summary (based on averages)</h5>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
        <tbody>
          <tr>
            <td style={{ fontWeight: 'bold', padding: '10px', border: '1px solid #ccc' }}>
              Average Exported Amount (S$) <br />
              <small style={{ fontWeight: 'normal', color: '#666' }}>{dateRange}</small>
            </td>
            <td style={{ textAlign: 'right', padding: '10px', border: '1px solid #ccc' }}>
              {avgExportedAmount.toFixed(2)}
            </td>
          </tr>
          <tr>
            <td style={{ fontWeight: 'bold', padding: '10px', border: '1px solid #ccc' }}>
              Average Consumed Amount (S$) <br />
              <small style={{ fontWeight: 'normal', color: '#666' }}>{dateRange}</small>
            </td>
            <td style={{ textAlign: 'right', padding: '10px', border: '1px solid #ccc' }}>
              {avgConsumedAmount.toFixed(2)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontWeight: 'bold',
                padding: '10px',
                border: '1px solid #ccc',
                backgroundColor: '#FFFF8F',
              }}
            >
              Estimated {nextBillingMonth} Invoice Total (S$)
            </td>
            <td
              style={{
                textAlign: 'right',
                padding: '10px',
                border: '1px solid #ccc',
                backgroundColor: '#FFFF8F',
              }}
            >
              {totalEstimatedBill.toFixed(2)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default EstimatedInvoiceSummary;
